import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const DynamicContent16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.2966 3.35168C10.2966 2.05288 11.3495 1 12.6483 1C13.9471 1 15 2.05288 15 3.35168C15 4.43996 14.2608 5.35559 13.257 5.62381V7.13023C13.257 7.44581 13.1317 7.74846 12.9085 7.9716C12.6854 8.19475 12.3827 8.32011 12.0672 8.32011H3.96038V10.3762C4.96411 10.6444 5.70336 11.56 5.70336 12.6483C5.70336 13.9471 4.65047 15 3.35168 15C2.05288 15 1 13.9471 1 12.6483C1 11.56 1.73925 10.6444 2.74299 10.3762V8.29203C2.7433 7.97666 2.86879 7.67371 3.09191 7.45082C3.31502 7.22792 3.61749 7.10272 3.93287 7.10272H12.0396V5.62382C11.0359 5.35561 10.2966 4.43998 10.2966 3.35168ZM12.6483 2.21739C12.0219 2.21739 11.514 2.72523 11.514 3.35168C11.514 3.97813 12.0219 4.48596 12.6483 4.48596C13.2748 4.48596 13.7826 3.97813 13.7826 3.35168C13.7826 2.72523 13.2748 2.21739 12.6483 2.21739ZM3.3469 11.514C2.72265 11.5166 2.21739 12.0235 2.21739 12.6483C2.21739 13.2748 2.72523 13.7826 3.35168 13.7826C3.97813 13.7826 4.48596 13.2748 4.48596 12.6483C4.48596 12.0219 3.97813 11.514 3.35168 11.514C3.35008 11.514 3.34849 11.514 3.3469 11.514Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
